window.addEventListener('message', (event) => {
	if(event.data.eventName == 'onFormReady') {
		var hbsptFields = '.hbspt-form form input:not([type="checkbox"]):not([type="date"]):not([type="radio"]):not([type="submit"]), .hbspt-form form select';

		[].slice.call(document.querySelectorAll(hbsptFields)).forEach(function(field) {
			if(field.value) {
				toggleLabelDisplay(field, true);
			}

			field.addEventListener('input', function() {
				toggleLabelDisplay(this, this.value);
			});
		});
	}
});

var formFields = '.ajax-form:not(#newsletter-form) input:not([type="checkbox"]):not([type="date"]):not([type="radio"]):not([type="submit"]), .ajax-form:not(#newsletter-form) select';

[].slice.call(document.querySelectorAll(formFields)).forEach(function(field) {
	field.addEventListener('input', function() {
		this.parentNode.previousSibling.style.opacity = this.value ? 0 : 1;
	});
});

function toggleLabelDisplay(field, hide) {
	var label = document.querySelector('label[for="'+field.id+'"]');

	if(label) {
		label.style.opacity = hide ? 0 : 1;
	}
}

const animationDuration = 2000;
const frameDuration = 1000 / 60;
const totalFrames = Math.round( animationDuration / frameDuration );
const easeOutQuad = t => t * ( 2 - t );

const animateCountUp = el => {
	let frame = 0;
	const countTo = parseInt(el.innerHTML);
	const counter = setInterval( () => {
		frame++;

		const progress = easeOutQuad( frame / totalFrames );
		const currentCount = Math.round( countTo * progress );

		if ( parseInt(el.innerHTML) !== currentCount ) {
			el.innerHTML = currentCount;
		}

		if ( frame === totalFrames ) {
			clearInterval( counter );
		}
	}, frameDuration );
};

if(document.querySelector('#insurance-center-contact')) {
	var ran = false;
	var insuranceSection = document.querySelector('#insurance-center-contact');
	var numberElement = insuranceSection.querySelector('h2 > u');
	var trustlogosWaypoint = new Waypoint({
		element: insuranceSection,
		handler: function(direction) {
			if(direction == 'down' && !ran) {
				animateCountUp(numberElement);
				ran = true;
			}
		},
		offset: checkWidth(480) && window.innerHeight > 552 ? '80%' : '95%'
	});
}